













































































































































import { Vue, Component } from 'vue-property-decorator';
import TabsComponent from './tabs.vue';
import { alert } from '@/common/modal';
import { RouteNames } from './_routes';
import { Sessions } from '@lantern/lantern-sdk';
import { router } from '../../main';

// eslint-disable-next-line no-undef
const retry = require('async-retry');
export const retryOptions = {
    retries: 5,
    minTimeout: 15,
    maxTimeout: 4000,
};

interface Children {
    id: string;
    label: string;
    children: Children[];
};

@Component({
    components: {
        tabs: TabsComponent,
    }
})

export default class ImportAppRulesComponent extends Vue {
    routerNames = RouteNames;
    uploadError = false;
    formatError = '';

    uploadLocked = false;
    modal: any = {
        errorIds: {
            show: false,
            errorIds: [] as string[]

        },
        info: {
            show: false
        }
    }

    // parced data from the server
    parsedDoc: Sessions.CsvResponce | null = null;

    // main entrance
    async filesChange(event: any) {

        // const fieldName = event.target.name;
        const fileList = event.target.files;

        this.formatError = '';
        if (!fileList.length) return;
        const validExts = ['.xlsx', '.xls', '.csv'];
        const fileExt = fileList[0].name.substring(
            fileList[0].name.lastIndexOf('.')
        );
        if (validExts.indexOf(fileExt) < 0) {
            this.formatError = `Sorry, that is not a valid CSV file: ${fileList[0].name}`;
            event.target.value = '';

            return;
        }

        // procees file
        this.parseCVSFile(fileList[0]);
        event.target.value = '';
    }

    async parseCVSFile(file: { name: string; size: number }) {

        this.uploadError = false;
        this.uploadLocked = true;
        try {
            const routParam = this.$route.params;
            if ('facilityId' in routParam) {

                console.log('parseCVSFile');
                const result = await this.$lantern.endpoints.Sessions.importCSVAppRules(
                    file,
                    routParam.facilityId,
                );

                //  save data
                this.parsedDoc = result.data;

                // check if there are any errors with IDs
                if (result.data.errorIds.length !== 0) {
                    this.modal.errorIds.show = true;
                    this.modal.errorIds.errorIds = result.data.errorIds;
                    return;
                }

                await this.parceDataCSVClient();

            }

        } catch (err) {
            console.log(err);
            this.uploadLocked = false;
            await alert(`Error: Cannot parse CSV file, please check the file format.`);
        }

    }

    async parceDataCSVClient() {

        if ((this.parsedDoc?.inmates.length === 0)) {
            await alert('There are no inmates to proccess');
            this.reset();
            return;
        }

        this.uploadLocked = false;
    }

    async confirm() {

        if (!this.parsedDoc) return;
        this.uploadLocked = true;

        let docs: {id: string; createdOn: string}[] = [];
        let prop: string = '';

        const inmateEnrollments: Sessions.InmateEnrollment[] = [];
        // eslint-disable-next-line array-callback-return
        this.parsedDoc.inmates.map(inmate => {
            const convertedInmate = {
                inmateId: inmate.inmateId,
                enableLanternStudentApp: inmate.enableLanternStudentApp,
                enableOfficeSuite: inmate.enableOfficeSuite,
                enableJSTOR: inmate.enableJSTOR
            };
            inmateEnrollments.push(convertedInmate);
        });

        const registerData = {
            facilityId: this.$route.params.facilityId,
            createdBy: this.$cache.user.value!.id,
            inmateEnrollments,
            registrationCount: this.parsedDoc.registrationCount,
            studentCount: this.parsedDoc.studentCount,
            type_session: 1
        };

        try {
            const responce = await this.$lantern.endpoints.Sessions.create({ ...registerData });
            console.log(`responce session:`);
            console.log(responce);

            docs = responce.data;
            const PropsObj = {
                id: registerData!.studentCount.toString(),
                docs
            };
            prop = JSON.stringify(PropsObj);
            console.log(prop);
        } catch (error) {
            await alert('Cannot create session! Please try later!');
            this.uploadLocked = false;
        }

        // enqueue to amazon
        if (docs.length !== 0) {

            for (const doc of docs) {

                // eslint-disable-next-line no-await-in-loop
                await retry(async () => {
                    const result = await this.$lantern.endpoints.Aws.enqueueAppsSession({ id: doc.id, createdOn: new Date(doc.createdOn) });
                    return result;
                }, {
                    ...retryOptions,
                    onRetry: async (err: any) => {
                        await alert('Session was created, but the task cannot be enqueued! Please try later to re-send the task on the Past Sessions screen');
                        console.log(err);
                    }
                });
            }

            this.reset();
            this.navigateTo(this.routerNames.finish, prop);
            this.uploadLocked = false;
        }
    }

    navigateTo(page: RouteNames, prop? : string) {

        if (prop) {
            router.push({ name: page, params: { data: prop } });
        } else {
            router.push(page);
        }
    }

    cancel() {
        this.reset();
    }

    // #endregion FILE

    // #region POPUP ACTIONS
    async proceedWithErrors(go: boolean) {
        if (go) {
            this.modal.errorIds.show = false;
            await this.parceDataCSVClient();
        } else {
            this.modal.errorIds.show = false;
            this.reset();
        }

    }

    async showDetail() {
        this.modal.info.show = true;
    }

    async downloadTestCSV() {

        const rows = [
            ['120285', 'true', 'true'],
            ['120286', 'false', 'false']
        ];

        const csvContent = `data:text/csv;charset=utf-8,${
            rows.map(e => e.join(',')).join('\n')}`;

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'example.csv');
        document.body.appendChild(link); // Required for FF

        link.click();

    }
    // #endregion POPUP ACTIONS

    reset() {
        this.uploadLocked = false;
        this.parsedDoc = null;
    }
}
